import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';

function FyersTokenGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { api } = useAppContext();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const validateToken = async () => {
      setIsChecking(true);

      try {
        const response = await api.getTokenValidation();

        if (!isMounted) {
          return;
        }

        if (response?.data?.s !== 'ok' || response?.data?.code !== 200) {
          navigate('/fyers/login', {
            replace: true,
            state: { from: location.pathname }
          });
          return;
        }

        setIsChecking(false);
      } catch (error) {
        if (isMounted) {
          navigate('/fyers/login', {
            replace: true,
            state: { from: location.pathname }
          });
        }
      }
    };

    validateToken();

    return () => {
      isMounted = false;
    };
  }, [api, location.pathname, navigate]);

  if (isChecking) {
    return (
      <div className="app-shell">
        <main className="main-content">
          <section className="panel-section">
            <div className="table-card" style={{ padding: '32px' }}>
              <p className="eyebrow">Broker Validation</p>
              <h3 style={{ marginTop: 0 }}>Checking Fyers session</h3>
              <p className="supporting-text dark-text">
                The admin dashboard is validating the broker token before loading protected tools.
              </p>
            </div>
          </section>
        </main>
      </div>
    );
  }

  return children;
}

export default FyersTokenGuard;
